import React from "react";
import { Slider, Handles, Rail, Tracks } from "react-compound-slider";

const RangeSlider = (props) => {
  const { handleSliderChange, domain, values } = props;

  return (
    <div>
      <Slider
        rootStyle={sliderStyle}
        domain={domain ? domain : [16, 65]}
        step={1}
        mode={2}
        values={values /* three values = three handles */}
        onChange={handleSliderChange}
      >
        <Rail>
          {({ getRailProps }) => <div style={railStyle} {...getRailProps()} />}
        </Rail>
        <Handles>
          {({ handles, getHandleProps }) => (
            <div className="slider-handles">
              {handles.map((handle) => (
                <Handle
                  key={handle.id}
                  handle={handle}
                  getHandleProps={getHandleProps}
                />
              ))}
            </div>
          )}
        </Handles>
        <Tracks left={false} right={false}>
          {({ tracks, getTrackProps }) => (
            <div className="slider-tracks">
              {tracks.map(({ id, source, target }) => (
                <Track
                  key={id}
                  source={source}
                  target={target}
                  getTrackProps={getTrackProps}
                />
              ))}
            </div>
          )}
        </Tracks>
      </Slider>
    </div>
  );
};

export default RangeSlider;

const sliderStyle = {
  // Give the slider some width
  position: "relative",
  width: "100%",
  height: 60,
  // border: '1px solid steelblue',
};

const railStyle = {
  position: "absolute",
  width: "100%",
  height: 8,
  marginTop: 35,
  borderRadius: 4,
  backgroundColor: "#cbd5e0",
};

function Handle({ handle: { id, value, percent }, getHandleProps }) {
  return (
    <div
      style={{
        left: `${percent}%`,
        position: "absolute",
        marginLeft: -15,
        marginTop: 28,
        zIndex: 2,
        width: 20,
        height: 20,
        border: 0,
        textAlign: "center",
        cursor: "pointer",
        borderRadius: "50%",
        backgroundColor: "#4517a6",
        // color: "#333"
      }}
      {...getHandleProps(id)}
    >
      <div style={{ fontSize: 11, marginTop: -25 }}>{value}</div>
    </div>
  );
}

function Track({ source, target, getTrackProps }) {
  return (
    <div
      style={{
        position: "absolute",
        height: 8,
        zIndex: 1,
        marginTop: 35,
        backgroundColor: "#4517a6",
        borderRadius: 5,
        cursor: "pointer",
        left: `${source.percent}%`,
        width: `${target.percent - source.percent}%`,
      }}
      {
        ...getTrackProps() /* this will set up events if you want it to be clickeable (optional) */
      }
    />
  );
}
